var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"img_box"},[_c('img',{staticClass:"bangzhu",attrs:{"src":require("../assets/img/bangzhu1.png"),"alt":""},on:{"click":function($event){return _vm.gotopathKe()}}}),_c('img',{staticClass:"kefu",attrs:{"src":require("../assets/img/kefu_a.png"),"alt":""},on:{"click":function($event){return _vm.gotopath()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }